let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("ffEVr"), load("4jPsO"), load("hPalR"), load("7AsyI")]).then(() => parcelRequire('480Js'));